import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router";
import keyIcon from "../assets/IconeSvg/key-square.svg";
import iconeDeconnexion from "../assets/IconeSvg/logout.svg";
import logo from "../assets/Images/LEADERSHIPFORGOD_logo_small.png";

const SideBarBackoffice = () => {
  const navigate = useNavigate();

  const [connectedUser, setConnectedUser] = useState([]);

  const deconnectAdmin = () => {
    localStorage.removeItem("compte_admin");
    navigate("/");
  };

  useEffect(() => {
    const token = localStorage.getItem("compte_admin");
    const decoded = token ? jwtDecode(token) : null;

    setConnectedUser(decoded);
  }, []);

  console.log("connecteedUser: ", connectedUser);

  return (
    <div className="bg-white rounded-2xl shadow-lg min-h-screen lg:w-72 xl:block lg:block hidden">
      <div className="flex flex-col justify-between px-3 xl:px-5 pt-3 w-full h-full">
        <div className="flex flex-col">
          <div className="flex flex-col justify-center items-center pb-[2rem] pt-[1rem] border-b-[2px] ">
            <div className="border-[2px] border-primary w-14 h-14 flex items-center justify-center rounded-full">
              <img src={logo} alt="" className="w-12 h-12 rounded-full  " />
            </div>
            <span className="italic text-xs text-gray-400">Administrateur</span>
            <h1 className="text-[14px] text-black font-bold text-start">
              {connectedUser ? `${connectedUser?.name}` : null}
            </h1>
            <h1 className="text-sm text-[#747474] font-semibold text-start">
              {connectedUser ? `${connectedUser?.email}` : null}
            </h1>
          </div>

          <div className="main-menu flex flex-col gap-y-1  mt-3 px-2">
            <NavLink to={"/dashboard"}>
              <button className=" w-full px-1 py-1.5 flex items-center gap-x-2 text-[#3E3E3E] font-medium">
                <span className="text-left text-[#3E3E3E] text-sm lg:text-base">
                  Aperçu générale
                </span>
              </button>
            </NavLink>
            <NavLink to={"/produits"}>
              <button className=" w-full px-1 py-1.5 flex items-center gap-x-2 text-[#3E3E3E] font-medium">
                <span className="text-left text-[#3E3E3E] text-sm lg:text-base">
                  Produits
                </span>
              </button>
            </NavLink>


            <NavLink to={"/comptesClients"}>
              <button className="bg-white w-full px-1 py-1.5 flex items-center gap-x-2 text-[#3E3E3E] font-medium">
                <span className="text-left text-sm lg:text-base">
                 Comptes clients
                </span>
              </button>
            </NavLink>

            <>
              {/* <NavLink to={"/commandes"}>
                <button className=" w-full px-1 py-1.5 flex items-center gap-x-2 text-[#3E3E3E] font-medium">
                  <span className="text-left text-[#3E3E3E] text-sm lg:text-base">
                    Commandes
                  </span>
                </button>
              </NavLink> */}
              <NavLink to={"/parametrages"}>
                <button className="bg-white w-full px-1 py-1.5 flex items-center gap-x-2 text-[#3E3E3E] font-medium">
                  <span className="text-left text-sm lg:text-base">
                    Paramètres
                  </span>
                </button>
              </NavLink>
              <NavLink to={"/admins"}>
                <button className="bg-white w-full px-1 py-1.5 flex items-center gap-x-2 text-[#3E3E3E] font-medium">
                  <span className="text-left text-sm lg:text-base">
                    Administrateurs
                  </span>
                </button>
              </NavLink>
            </>
          </div>
        </div>

        {/* <div className=" w-full pb-1">
          <div className="w-full dropdown dropdown-top dropdown-start">
            <div tabIndex={0} role="button" className="mt-1">
              <button className="text-base text-white rounded-lg bg-black font-medium w-full flex items-center py-2 mt-2 gap-x-2 justify-center">
                <span className="text-left text-sm lg:text-base">
                  Compte utilisateur
                </span>
              </button>
            </div>
            <ul
              tabIndex={0}
              className="dropdown-content menu bg-base-100 rounded-xl z-[1] w-full mx-auto p-2 shadow border"
            >
              <button
                className="w-full mx-auto h-11 bg-gray-100 text-sm text-black font-semibold flex items-center gap-x-2 px-4 rounded-xl"
                onClick={() => {
                  document.getElementById("update-password").showModal();
                }}
              >
                <img src={keyIcon} className="w-6" />
                <span>Mot de passe</span>
              </button>
              <button
                className="mt-2 w-full mx-auto h-11 bg-black text-sm text-white font-semibold flex items-center gap-x-2 px-4 rounded-xl"
                onClick={() => deconnectAdmin()}
              >
                <img src={iconeDeconnexion} className="w-6" />
                <span>Déconnexion</span>
              </button>
            </ul>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default SideBarBackoffice;
